import React from "react";
// styles
import injectSheet from 'react-jss';
import styles from './inputform_styles';

const InputForm = injectSheet(styles)((props) => {
  return (
    <div className={props.classes.inputForm}>
      <div className="flexHorizontal">
        <div className={`formelement ${props.isNumber ? "numberStyle" : "textStyle"} ${props.klass}`}>
          <input
            maxLength={`${!props.isNumber && 9}`}
            className={`textfield ${props.isNumber && "numberAlign"}`}
            type={props.isNumber ? "number" : "text"}
            name={props.name}
            value={props.value}
            onChange={props.handleChange}
            onPaste={props.handlePaste}
            onKeyPress={props.handleKeyPress}
            disabled={props.disabled}
          />
        </div>
        {props.isNumber && "%"}
      </div>
    </div>
  )
});

export default InputForm;